<template>
  <div id="page-user-list">
    <div class="vx-card p-6 card-user-list">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  totalUser - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : totalUser
                }}
                / {{ totalUser }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="onChangePageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="onChangePageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="onChangePageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <vs-button
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          icon-pack="feather"
          icon="icon-plus"
          color="primary"
          type="filled"
          :to="{
            name: 'enterprise-management-user-add',
          }"
          >新しい社員を登録する</vs-button
        >
        <vs-button
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          icon-pack="feather"
          icon="icon-list"
          color="success"
          :to="{
            name: 'enterprise-management-user-sort',
          }"
          >表示順序を変更する</vs-button
        >
        <vs-button
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          icon-pack="feather"
          icon="icon-search"
          color="primary"
          type="border"
          @click="showDialogSearchCondition"
          >検索条件を変更する</vs-button
        >
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="dispUsers"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :suppressDragLeaveHidesColumns="true"
        :suppressNoRowsOverlay="true"
        @grid-ready="onGridReady"
        @rowClicked="rowClicked"
        @dragStopped="onDragStopped"
      >
      </ag-grid-vue>

      <vs-pagination
        v-if="isReadyPagination"
        :total="totalPages"
        :max="7"
        v-model="currentPage"
      />
    </div>
    <!-- ダイアログ -->
    <dialog-retirement-processing
      ref="dialogRetirementProcessing"
      @doneRetirementProcessing="updatedRetirementDate"
    ></dialog-retirement-processing>
    <dialog-user-search-condition
      :searchCondition.sync="searchCondition"
      ref="dialogUserSearchCondition"
      @searchUsers="onSearchUsers"
    ></dialog-user-search-condition>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererRetirementStatus from "./cell-renderer/CellRendererRetirementStatus.vue";
import CellRendererLicenseStatus from "./cell-renderer/CellRendererLicenseStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import DialogRetirementProcessing from "@/components/dialogs/DialogRetirementProcessing";
import DialogUserSearchCondition from "@/components/dialogs/DialogUserSearchCondition";
import FireStoreService from "@/services/fireStoreService";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const eplApi = AiseaApiFactory.get("enterpriseLicense");
const euApi = AiseaApiFactory.get("enterpriseUser");
import Vue from "vue";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("enterpriseUserList");
const INITIAL_PAGE_SIZE = 10;

export default {
  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererLink,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererRetirementStatus,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererLicenseStatus,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererVerified,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererActions,
    DialogRetirementProcessing,
    DialogUserSearchCondition,
  },
  data() {
    return {
      searchCondition: {
        name: "",
        isRetirement: "currently",
        isDeleted: false,
        page: this.getCurrentPage(),
        limit: INITIAL_PAGE_SIZE,
      },
      currentPage: 1,
      searchQuery: "",
      searchUserName: "",
      // AgGrid
      gridApi: null,
      gridOptions: {
        localeText: { noRowsToShow: "社員が見つかりませんでした" },
        context: {
          componentParent: this,
        },
      },
      pageSize: INITIAL_PAGE_SIZE,
      defaultColDef: {
        sortable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: null,
      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererRetirementStatus,
        CellRendererLicenseStatus,
        CellRendererVerified,
        CellRendererActions,
      },
      userDataForRetirementProcessing: null,
      licenseInfoMap: {},
      isReadyPagination: false,
      prevRoute: null,
    };
  },
  watch: {
    currentPage() {
      FireStoreService.setAccountSetting("user_list", {
        current_page: this.currentPage,
      });
      this.searchUsers();
    },
    userDataForRetirementProcessing(userData) {
      this.$refs.dialogRetirementProcessing.show(userData);
    },
  },
  computed: {
    ...mapState({
      users: state => state.users,
      pageable: state => state.pageable,
    }),
    dispUsers() {
      return JSON.parse(JSON.stringify(this.users)).map(user => {
        user.name = user.name || user.name_en;
        user.license = this.licenseInfoMap[user.user_id];
        return user;
      });
    },
    paginationPageSize() {
      return this.pageSize;
    },

    totalPages() {
      if (this.pageable) return this.pageable.total_pages;
      else return 0;
    },

    totalUser() {
      if (this.pageable) return this.pageable.total_elements;
      else return 0;
    },
  },
  methods: {
    ...mapActions(["fetchUsers", "resetUserListState"]),

    async onGridReady() {
      const initialColumnDefs = [
        {
          headerName: "社員番号",
          field: "origin_number",
        },
        {
          headerName: "名前",
          field: "name",
          cellRenderer: "CellRendererLink",
        },
        {
          headerName: "在籍状況",
          field: "retirement_date",
          filter: true,
          cellRenderer: "CellRendererRetirementStatus",
        },
        {
          headerName: "免許・資格",
          field: "license",
          cellRenderer: "CellRendererLicenseStatus",
        },
      ];
      let columnDefs = [];
      const userListSetting = await FireStoreService.getAccountSetting(
        "user_list"
      );

      if (
        userListSetting &&
        userListSetting.columns &&
        userListSetting.columns.length > 0
      ) {
        userListSetting.columns.forEach(columnId => {
          const columnDef = initialColumnDefs.find(
            columnDef => columnDef.field === columnId
          );
          if (columnDef) {
            columnDefs.push(columnDef);
          }
        });
      } else {
        columnDefs = initialColumnDefs;
      }
      this.columnDefs = columnDefs;
      this.pageSize =
        userListSetting && userListSetting.page_size
          ? userListSetting.page_size
          : INITIAL_PAGE_SIZE;
      this.$nextTick(async () => {
        await this.restoreSearchCondition(userListSetting);
        this.searchUsers();
      });
      this.autoSizeAll();
    },

    setPageSize(size) {
      this.pageSize = size;
      FireStoreService.setAccountSetting("user_list", {
        page_size: this.pageSize,
      });
    },

    getCurrentPage() {
      return this.currentPage - 1;
    },

    async restoreSearchCondition(userListSetting) {
      const prevRouteName =
        this.prevRoute && this.prevRoute.name ? this.prevRoute.name : "";

      if (!prevRouteName.startsWith("enterprise-management-user-")) {
        // 社員管理以外から来た場合は１ページ目から
        this.currentPage = 1;
      } else if (
        prevRouteName.endsWith("-sort") ||
        prevRouteName.endsWith("-add")
      ) {
        // 社員追加、表示順序変更は１ページ目から （ この時点ではsearchUsers()前なので、totalPagesは0 ）
        this.currentPage = 1;
      } else if (
        prevRouteName.endsWith("-view") &&
        this.prevRoute.params.userId
      ) {
        // 詳細から戻った場合、削除処理以外なら、ページ番号等をリストア
        let res = await euApi.fetch(this.prevRoute.params.userId);
        if (res.code === 404 || res.status === false) {
          this.currentPage = 1;
        } else {
          const searchCondition =
            userListSetting && userListSetting.search_condition
              ? userListSetting.search_condition
              : {};
          this.searchCondition = {
            ...this.searchCondition,
            name: searchCondition.name || "",
            isRetirement: searchCondition.is_retirement || "currently",
            isDeleted: searchCondition.is_deleted || false,
            limit: userListSetting.page_size,
          };
          this.currentPage =
            userListSetting && userListSetting.current_page
              ? userListSetting.current_page
              : 1;
        }
      } else {
        // 上記以外の社員管理画面からの遷移は、ページ番号等をリストア
        const searchCondition =
          userListSetting && userListSetting.search_condition
            ? userListSetting.search_condition
            : {};
        this.searchCondition = {
          ...this.searchCondition,
          name: searchCondition.name || "",
          isRetirement: searchCondition.is_retirement || "currently",
          isDeleted: searchCondition.is_deleted || false,
          limit: userListSetting.page_size,
        };
        this.currentPage =
          userListSetting && userListSetting.current_page
            ? userListSetting.current_page
            : 1;
      }

      // currentPage は vs-pagination がロードされる前に初期値をセットしておく。
      this.isReadyPagination = true;
    },

    rowClicked(evt) {
      this.$router.push({
        name: "enterprise-management-user-view",
        params: { userId: evt.data.user_id },
      });
    },

    onDragStopped(e) {
      const userListOrder =
        e.columnApi.getAllGridColumns().map(x => x.colId) || [];
      FireStoreService.setAccountSetting("user_list", {
        columns: userListOrder,
      });
    },

    showDialogSearchCondition() {
      this.$refs.dialogUserSearchCondition.show();
    },

    onChangePageSize(size) {
      this.setPageSize(size);
      this.currentPage = 1;
      this.searchUsers();
    },

    onSearchUsers() {
      FireStoreService.setAccountSetting("user_list", {
        search_condition: {
          name: this.searchCondition.name || "",
          is_retirement: this.searchCondition.isRetirement || "currently",
          is_deleted: this.searchCondition.isDeleted || false,
        },
      });
      this.currentPage = 1;
      this.searchUsers();
    },

    async searchUsers() {
      let payload = {
        name: this.searchCondition.name,
        is_retirement: this.getDisabled(),
        is_deleted: false,
        page: this.getCurrentPage(),
        limit: this.paginationPageSize,
      };
      this.$vs.loading();
      try {
        await this.fetchUsers(payload);
        this.addLicenseInfoMap();
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    },

    addLicenseInfoMap() {
      this.users.forEach(async user => {
        let res = await eplApi.fetch(user.user_id);
        if (res && res.status) {
          Vue.set(this.licenseInfoMap, user.user_id, res.data.licenses);
        }
      });
    },

    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },

    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },

    showDialogRetirementProcessing() {
      this.$refs.dialogRetirementProcessing.show();
    },

    updatedRetirementDate() {},

    getDisabled() {
      if (this.searchCondition.isRetirement === "all") {
        return "";
      }
      if (this.searchCondition.isRetirement === "currently") {
        return false;
      }
      if (this.searchCondition.isRetirement === "retirement") {
        return true;
      }
    },

    autoSizeAll() {
      let allColumnIds = [];
      this.gridColumnApi.getAllColumns().forEach(function(column) {
        allColumnIds.push(column.getId());
      });
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    },

    cleanup() {
      this.resetUserListState();
    },
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";

    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    let self = this;
    window.onresize = function() {
      self.gridApi.sizeColumnsToFit();
    };
  },
  beforeDestroy() {
    this.cleanup();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
};
</script>

<style lang="scss">
#page-user-list {
  .vs-avatar--con-img img {
    object-fit: cover;
  }
  .ag-grid-table {
    height: calc(100% - 120px);
  }
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
  .card-user-list {
    height: calc(100vh - 120px);
  }
}
</style>
